const NON_PROD_LOG = (message: string, ...other: any) =>
  process.env.NODE_ENV === "development" && console.log(message, ...other);

export { NON_PROD_LOG };
